import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, MapPin, Mail, Facebook, Twitter, Linkedin, Youtube, Send, User, MessageSquare } from 'lucide-react';

const Contact1 = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    console.log('Form submitted:', formData);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.4, 0.25, 1]
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: [0.25, 0.4, 0.25, 1]
      }
    }
  };

  return (
    <div className="min-h-screen bg-white py-16 px-4">
      <motion.div 
        className="max-w-7xl mx-auto"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Header */}
        <motion.div 
          className="mb-4 text-slate-400 font-light tracking-wider text-xs uppercase"
          variants={itemVariants}
        >
       
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left Side - Content */}
          <motion.div variants={itemVariants}>
            <motion.h1 
              className="text-4xl lg:text-5xl font-light text-slate-900 leading-tight mb-6 tracking-tight"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              We are always ready<br />
              to help you and<br />
              answer your<br />
              <span className="text-orange-500">questions</span>
            </motion.h1>

            <motion.p 
              className="text-slate-500 font-light text-sm mb-10 leading-relaxed max-w-md"
              variants={itemVariants}
            >
              Pacific habit false trivially queen parturition black pricesstock 
              mosshead warsonnet sweepest Greenling sleeper.
            </motion.p>

            {/* Contact Info Grid */}
            <div className="grid md:grid-cols-2 gap-6">
              {/* Call Center */}
              <motion.div 
                className="bg-white rounded-lg p-5 border border-slate-100 hover:border-orange-200 transition-all duration-300"
                variants={cardVariants}
                whileHover={{ scale: 1.01, y: -2 }}
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="bg-orange-500 p-2 rounded-lg">
                    <Phone className="w-3 h-3 text-white" />
                  </div>
                  <h3 className="text-sm font-medium text-slate-800">Call Center</h3>
                </div>
                <div className="space-y-1">
                  <p className="text-slate-500 font-light text-xs">(800) 349 95 70 36</p>
                  <p className="text-slate-500 font-light text-xs">+ (123) 1800 234 5678</p>
                </div>
              </motion.div>

              {/* Our Location */}
              <motion.div 
                className="bg-white rounded-lg p-5 border border-slate-100 hover:border-orange-200 transition-all duration-300"
                variants={cardVariants}
                whileHover={{ scale: 1.01, y: -2 }}
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="bg-orange-500 p-2 rounded-lg">
                    <MapPin className="w-3 h-3 text-white" />
                  </div>
                  <h3 className="text-sm font-medium text-slate-800">Our Location</h3>
                </div>
                <div className="space-y-1">
                  <p className="text-slate-500 font-light text-xs">USA, New York - 1060</p>
                  <p className="text-slate-500 font-light text-xs">Str. First Avenue 1</p>
                </div>
              </motion.div>

              {/* Email */}
              <motion.div 
                className="bg-white rounded-lg p-5 border border-slate-100 hover:border-orange-200 transition-all duration-300"
                variants={cardVariants}
                whileHover={{ scale: 1.01, y: -2 }}
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="bg-orange-500 p-2 rounded-lg">
                    <Mail className="w-3 h-3 text-white" />
                  </div>
                  <h3 className="text-sm font-medium text-slate-800">Email</h3>
                </div>
                <p className="text-slate-500 font-light text-xs">neuros@mail.co</p>
              </motion.div>

              {/* Social Network */}
              <motion.div 
                className="bg-white rounded-lg p-5 border border-slate-100 hover:border-orange-200 transition-all duration-300"
                variants={cardVariants}
                whileHover={{ scale: 1.01, y: -2 }}
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="bg-orange-500 p-2 rounded-lg">
                    <MessageSquare className="w-3 h-3 text-white" />
                  </div>
                  <h3 className="text-sm font-medium text-slate-800">Social network</h3>
                </div>
                <div className="flex gap-2">
                  {[
                    { icon: Facebook, color: 'hover:text-blue-600' },
                    { icon: Twitter, color: 'hover:text-sky-500' },
                    { icon: Linkedin, color: 'hover:text-blue-700' },
                    { icon: Youtube, color: 'hover:text-red-600' }
                  ].map((social, index) => (
                    <motion.button
                      key={index}
                      className={`p-1.5 rounded-md bg-slate-50 text-slate-400 transition-all duration-300 ${social.color} hover:bg-slate-100`}
                      whileHover={{ scale: 1.1, y: -1 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <social.icon className="w-3 h-3" />
                    </motion.button>
                  ))}
                </div>
              </motion.div>
            </div>
          </motion.div>

          {/* Right Side - Contact Form */}
          <motion.div 
            className="bg-slate-50 rounded-2xl p-6 border border-slate-100"
            variants={itemVariants}
            whileHover={{ scale: 1.005 }}
            transition={{ duration: 0.3 }}
          >
            <motion.h2 
              className="text-lg font-medium text-slate-900 mb-2 tracking-tight"
              variants={itemVariants}
            >
              Get in Touch
            </motion.h2>
            
            <motion.p 
              className="text-slate-500 font-light text-xs mb-6 leading-relaxed"
              variants={itemVariants}
            >
              Define your goals and identify areas where AI can add value to your business
            </motion.p>

            <div className="space-y-4">
              <motion.div variants={itemVariants}>
                <label className="block text-xs text-left font-medium text-slate-600 mb-1">
                  Full name
                </label>
                <div className="relative">
                  <User className="absolute left-2.5 top-1/2 transform -translate-y-1/2 w-3 h-3 text-slate-400" />
                  <motion.input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    className="w-full pl-8 pr-3 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 transition-all duration-300 bg-white text-xs"
                    placeholder="Enter your full name"
                    whileFocus={{ scale: 1.005 }}
                  />
                </div>
              </motion.div>

              <motion.div variants={itemVariants}>
                <label className="block text-xs text-left font-medium text-slate-600 mb-1">
                  Email
                </label>
                <div className="relative">
                  <Mail className="absolute left-2.5 top-1/2 transform -translate-y-1/2 w-3 h-3 text-slate-400" />
                  <motion.input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full pl-8 pr-3 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 transition-all duration-300 bg-white text-xs"
                    placeholder="Enter your email address"
                    whileFocus={{ scale: 1.005 }}
                  />
                </div>
              </motion.div>

              <motion.div variants={itemVariants}>
                <label className="block text-xs text-left font-medium text-slate-600 mb-1">
                  Subject
                </label>
                <motion.input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 transition-all duration-300 bg-white text-xs"
                  placeholder="What is this about?"
                  whileFocus={{ scale: 1.005 }}
                />
              </motion.div>

              <motion.div variants={itemVariants}>
                <label className="block text-xs text-left font-medium text-slate-600 mb-1">
                  Message
                </label>
                <motion.textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={3}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 transition-all duration-300 bg-white resize-none text-xs"
                  placeholder="Tell us more about your inquiry..."
                  whileFocus={{ scale: 1.005 }}
                />
              </motion.div>

              <motion.button
                onClick={handleSubmit}
                className="w-full bg-orange-500 text-white py-3 px-4 rounded-lg text-xs font-medium flex items-center justify-center gap-2 hover:bg-orange-600 transition-all duration-300 shadow-sm hover:shadow-md"
                whileHover={{ scale: 1.01, y: -1 }}
                whileTap={{ scale: 0.99 }}
                variants={itemVariants}
              >
                <Send className="w-3 h-3" />
                Send a message
              </motion.button>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default Contact1;